import React, { useEffect, useState } from 'react'

import logo from 'assets/images/home/KION_GRADIENT.png'
import { Button, ScrollAnimation } from 'shared/components'
import { useIntersection } from 'shared/hooks'
import { Slider } from './Slider/Slider'

import classes from './Originals.module.scss'

export const HomeOriginalsBlockID = 'home-originals-block'

export const Originals = (): JSX.Element => {
  const [, entry] = useIntersection({})
  const [, setWidth] = useState('')

  useEffect(() => {
    const width = entry?.isIntersecting ? `${document.body.offsetWidth}px` : ''

    setWidth(width)
  }, [entry])

  const renderHeader = () => (
    <div
      className={`${classes.header} reveal-from-bottom-extra-large`}
      data-reveal-delay={80}
    >
      <img src={logo} alt="KION" className={classes.logo} />
      <p className={classes.text}>Истории, которые удивляют</p>
    </div>
  )

  const renderBtn = () => (
    <div
      className={`${classes.button_wrap} reveal-from-bottom-medium`}
      data-reveal-delay={10}
    >
      <a href="https://kion.ru/home" target="_blank" rel="noreferrer">
        <Button>Узнать больше о KION</Button>
      </a>
    </div>
  )

  return (
    <div className="container">
      <div className="row row_overflow">
        <div className="col-xs-12">
          <h2 className={`${classes.title}`}>KION ORIGINALS</h2>
        </div>

        <div
          className={`col-xs-12 ${classes.content}`}
          id={HomeOriginalsBlockID}
        >
          <h2
            className={`${classes.title_desktop} second-title reveal-from-bottom-medium`}
            data-reveal-delay={10}
          >
            KION ORIGINALS
          </h2>
          <ScrollAnimation
            animatedProp="width"
            maxWidth={window.innerWidth + 40}
            classes={classes.bg}
            speed={1.2}
            bothDirection
            removeBorderRadius
          />

          {renderHeader()}

          <Slider />

          {renderBtn()}
        </div>
      </div>
    </div>
  )
}
